/**
 * Dashboard service – revenue activity, subscription summary
 */
import APIClient from '../../../lib/api';

const DashboardService = {
  getRevenueActivity: async (params = {}) => {
    const res = await APIClient.dashboard.getRevenueActivity(params);
    return res?.data;
  },

  getSubscriptionSummary: async (params = {}) => {
    const res = await APIClient.dashboard.getSubscriptionSummary(params);
    return res?.data;
  },

  getSummary: async (period = '6months') => {
    const res = await APIClient.dashboard.getSummary(period);
    return res?.data;
  },
};

export default DashboardService;
